import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block text-sm font-medium text-gray-700 mb-1"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 1,
  class: "absolute z-50 mt-1 w-full min-w-[200px] bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-y-auto"
}
const _hoisted_4 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-500"
}
const _hoisted_5 = ["onClick", "disabled"]

import { ref, computed, watch } from 'vue';
import type { DropdownItem } from '@/types/v2/ui/dropdown.types';

// Define props
interface Props {
  index: number;
  label?: string;
  items: DropdownItem[];
  itemKey: string;
  selectedItem?: DropdownItem | null;
  disabled?: boolean;
  placeholder?: string;
  neutralStyle?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ItemDropdown',
  props: {
    index: {},
    label: { default: '' },
    items: {},
    itemKey: {},
    selectedItem: { default: null },
    disabled: { type: Boolean, default: false },
    placeholder: { default: 'Select an item...' },
    neutralStyle: { type: Boolean, default: false }
  },
  emits: ["fieldChange"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable no-undef */
const props = __props;

// Define emits
const emit = __emit;

// Local state
const isOpen = ref(false);
const dropdownRef = ref<HTMLElement>();

// Computed
const displayText = computed(() => {
  if (!props.selectedItem) return props.placeholder;
  
  // Try different property names for display text
  return props.selectedItem.name || 
         props.selectedItem.label || 
         props.selectedItem.title || 
         'Unknown';
});

const displayItems = computed(() => {
  return props.items || [];
});

const isSelectedItem = (item: DropdownItem) => {
  return !!(props.selectedItem && (props.selectedItem.key === item.key || props.selectedItem.name === item.name));
};

// Methods
const toggleDropdown = () => {
  if (!props.disabled) {
    isOpen.value = !isOpen.value;
  }
};

const selectItem = (item: DropdownItem) => {
  if (!props.disabled) {
    emit('fieldChange', {
      index: props.index,
      key: props.itemKey,
      item
    });
    isOpen.value = false;
  }
};

const closeDropdown = () => {
  isOpen.value = false;
};

// Handle clicks outside
const handleClickOutside = (event: Event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    closeDropdown();
  }
};

// Watch for outside clicks
watch(isOpen, (newVal) => {
  if (newVal) {
    document.addEventListener('click', handleClickOutside);
  } else {
    document.removeEventListener('click', handleClickOutside);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: toggleDropdown,
      disabled: _ctx.disabled,
      class: _normalizeClass(["flex items-center justify-between w-full min-w-[150px] text-sm border border-gray-300 rounded px-3 py-2 bg-white focus:outline-none focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors duration-150", {
        'focus:ring-blue-500 focus:border-blue-500': !_ctx.neutralStyle,
        'focus:ring-gray-300 focus:border-gray-400': _ctx.neutralStyle,
        'bg-gray-50': _ctx.disabled,
        'cursor-not-allowed': _ctx.disabled
      }])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["truncate flex-1 text-left", { 'text-gray-500': !_ctx.selectedItem }])
      }, _toDisplayString(displayText.value), 3),
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["h-4 w-4 text-gray-500 ml-2 flex-shrink-0 transition-transform duration-150", { 'rotate-180': isOpen.value }]),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor"
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 9l-7 7-7-7"
        }, null, -1)
      ]), 2))
    ], 10, _hoisted_2),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (displayItems.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No items available "))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(displayItems.value, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.key || item.name || item.label,
                  onClick: ($event: any) => (selectItem(item)),
                  disabled: _ctx.disabled,
                  class: _normalizeClass(["w-full px-3 py-2 text-left hover:bg-gray-50 focus:bg-gray-50 focus:outline-none transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed text-sm", [
            _ctx.neutralStyle
              ? (isSelectedItem(item) ? 'bg-gray-100 text-gray-900' : '')
              : (isSelectedItem(item) ? 'bg-blue-50 text-blue-700' : '')
          ]])
                }, _toDisplayString(item.name || item.label || item.title || 'Unknown'), 11, _hoisted_5))
              }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})